type Breakpoints = `xs` | `sm` | `md` | `lg` | `xl` | `xxl`;

const breakpoints: { [K in Breakpoints]: number } = {
  xs: 375,
  sm: 600,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1440,
};

const mediaQuery = (value: Breakpoints) => {
  const bpArray = Object.keys(breakpoints).map(key => [
    key,
    breakpoints[key as Breakpoints],
  ]);

  const [result] = bpArray.reduce((acc, [name, size]) => {
    if (value === name) return [...acc, `@media (min-width: ${size}px)`];
    return acc;
  }, []);

  return result;
};

export default mediaQuery;
